(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
  // This script only reflects Swym state; Swym keeps control of add/remove.
  if (window.pcBasicWishlistAnimationReady) return;
  window.pcBasicWishlistAnimationReady = true;

  const selector = '.pc-basic__wishlist.swym-button';
  const savedClass = 'pc-basic__wishlist--saved';
  const popClass = 'pc-basic__wishlist--bursting';
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const lastNativeState = new WeakMap();
  const pending = new Map();
  const bursts = new Map();
  const connectedLayers = new WeakSet();
  const svgNS = 'http://www.w3.org/2000/svg';
  const random = (min, max) => min + Math.random() * (max - min);
  const key = button => `${button.dataset.productId}:${button.dataset.variantId}`;

  function setSaved(button, active) {
    if (button.classList.contains(savedClass) !== active) button.classList.toggle(savedClass, active);
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', active ? 'Aus der Wunschliste entfernen' : 'Auf die Wunschliste setzen');
  }

  function syncNative(button) {
    const active = button.classList.contains('swym-added');
    if (lastNativeState.get(button) === active) return;
    lastNativeState.set(button, active);
    setSaved(button, active);
    if (!active) clearBurst(button);
  }

  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.(selector)) syncNative(root);
    root.querySelectorAll(selector).forEach(syncNative);
  }

  function clearBurst(button) {
    const burst = bursts.get(button);
    if (burst) {
      clearTimeout(burst.popTimer);
      clearTimeout(burst.cleanupTimer);
      burst.layer.remove();
      bursts.delete(button);
    }
    if (button.classList.contains(popClass)) button.classList.remove(popClass);
  }

  function clearAllBursts() {
    bursts.forEach((_, button) => clearBurst(button));
  }

  function animate(button) {
    clearBurst(button);
    if (motion.matches || !button.isConnected) return;
    const rect = button.getBoundingClientRect();
    if (!rect.width || !rect.height || rect.bottom < 0 || rect.top > window.innerHeight || rect.right < 0 || rect.left > window.innerWidth) return;
    const iconPath = button.querySelector('.pc-basic__wishlist-icon path')?.getAttribute('d');
    if (!iconPath) return;
    const pink = window.getComputedStyle(button).getPropertyValue('--pc-pink').trim() || '#dc54ef';

    // Mount outside the card so rounded corners and overflow cannot clip hearts.
    const layer = document.createElement('div');
    layer.className = 'pc-basic-wishlist-burst';
    layer.setAttribute('aria-hidden', 'true');
    layer.style.setProperty('--pc-pink', pink);
    layer.style.left = `${rect.left + rect.width / 2}px`;
    layer.style.top = `${rect.top + rect.height / 2}px`;

    for (let i = 0; i < 18; i++) {
      const angle = i / 18 * Math.PI * 2 + random(-.15, .15);
      const distance = random(55, 105);
      const startDistance = random(10, 18);
      const particle = document.createElementNS(svgNS, 'svg');
      particle.setAttribute('class', 'pc-basic-wishlist-burst__particle');
      particle.setAttribute('viewBox', '0 0 24 24');
      particle.setAttribute('aria-hidden', 'true');
      particle.setAttribute('focusable', 'false');
      particle.style.setProperty('fill', pink, 'important');
      const path = document.createElementNS(svgNS, 'path');
      path.setAttribute('d', iconPath);
      path.style.setProperty('fill', pink, 'important');
      particle.appendChild(path);
      const properties = {
        '--size': `${random(7, 15)}px`,
        '--start-x': `${Math.cos(angle) * startDistance}px`,
        '--start-y': `${Math.sin(angle) * startDistance}px`,
        '--end-x': `${Math.cos(angle) * distance}px`,
        '--end-y': `${Math.sin(angle) * distance - 18}px`,
        '--rotation': `${random(-65, 65)}deg`,
        '--duration': `${random(650, 1000)}ms`,
        '--delay': `${random(0, 90)}ms`,
        '--particle-color': pink
      };
      Object.entries(properties).forEach(([name, value]) => particle.style.setProperty(name, value));
      particle.addEventListener('animationend', () => particle.remove(), { once: true });
      layer.appendChild(particle);
    }
    document.body.appendChild(layer);
    void button.offsetWidth;
    button.classList.add(popClass);
    bursts.set(button, {
      layer,
      popTimer: setTimeout(() => button.classList.remove(popClass), 500),
      cleanupTimer: setTimeout(() => clearBurst(button), 1200)
    });
  }

  function matchesProduct(button, data) {
    if (data.empi == null && data.epi == null) return false;
    return (data.empi == null || String(data.empi) === button.dataset.productId)
      && (data.epi == null || String(data.epi) === button.dataset.variantId);
  }

  function onSwymChange(event, active) {
    const data = event.detail?.d || event.detail;
    if (!data) return;
    document.querySelectorAll(selector).forEach(button => {
      if (!matchesProduct(button, data)) return;
      setSaved(button, active);
      if (!active) clearBurst(button);
    });
    pending.forEach((action, productKey) => {
      if (!matchesProduct(action.button, data)) return;
      pending.delete(productKey);
      clearTimeout(action.timer);
      if (active && !action.wasSaved) animate(action.button);
    });
  }

  // Capture intent before Swym's click handler, without cancelling its event.
  document.addEventListener('click', event => {
    const button = event.target.closest?.(selector);
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    const productKey = key(button);
    const previous = pending.get(productKey);
    if (previous) clearTimeout(previous.timer);
    clearBurst(button);
    const action = {
      button,
      wasSaved: button.classList.contains(savedClass) || button.classList.contains('swym-added'),
      timer: setTimeout(() => pending.delete(productKey), 15000)
    };
    pending.set(productKey, action);
  }, true);

  function observeButtons() {
    scan(document);
    const observer = new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'attributes') {
          if (record.target.matches(selector)) syncNative(record.target);
        } else {
          record.addedNodes.forEach(scan);
        }
      });
      bursts.forEach((_, button) => { if (!button.isConnected) clearBurst(button); });
    });
    observer.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeButtons, { once: true });
  else observeButtons();

  document.addEventListener('scroll', clearAllBursts, { capture: true, passive: true });
  window.addEventListener('resize', clearAllBursts, { passive: true });
  window.addEventListener('pagehide', () => {
    clearAllBursts();
    pending.forEach(action => clearTimeout(action.timer));
    pending.clear();
  });
  motion.addEventListener('change', () => { if (motion.matches) clearAllBursts(); });

  // Register once via Swym's supported SDK-ready callback.
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(swat => {
    const layer = swat.evtLayer;
    if (!layer || connectedLayers.has(layer)) return;
    connectedLayers.add(layer);
    layer.addEventListener('sw:addedtowishlist', event => onSwymChange(event, true));
    layer.addEventListener('sw:removedfromwishlist', event => onSwymChange(event, false));
  });
})();
  } catch(e) { console.error(e); }
})();

})();
